import { makeStyles } from '@material-ui/core/styles';

import { NAVIGATION_BAR_HEIGHT } from 'src/data/common';

export const useStyles = makeStyles(
  (theme) => ({
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white,
      },
    },

    navigationBar: {
      position: 'fixed',
      width: '100%',
      zIndex: theme.zIndex.appBar,
    },
    pageWrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      paddingTop: NAVIGATION_BAR_HEIGHT,
    },
  }),
  { name: 'SharedPage' }
);
